import { UseMutateFunction, useMutation } from '@tanstack/react-query';
import { uploadCompressFile } from '@helper/fileUpload';

interface IKYCData {
	url?: string;
	kycFileData?: File | null;
}

interface IProfileData {
	url?: string;
	profileImageData?: File | null;
}

export interface IVariables {
	kycData?: IKYCData;
	profileData?: IProfileData;
}

interface KYCFileData {
	mutate: UseMutateFunction<
		unknown,
		Error,
		IVariables, // ✅ Uses the IVariables interface directly (with optional profileData)
		unknown
	>;
	error: Error | null;
	isError: boolean;
	isPending: boolean;
}

export const useKYCFileUploadMutation = (): KYCFileData => {
	const postKYCFileData = async (variables: IVariables): Promise<unknown> => {
		const { kycData, profileData } = variables;

		const promises: Promise<unknown>[] = [];

		if (kycData?.url && kycData?.kycFileData) {
			promises.push(uploadCompressFile(kycData.kycFileData, kycData.url));
		}

		if (profileData?.url && profileData?.profileImageData) {
			promises.push(uploadCompressFile(profileData.profileImageData, profileData.url));
		}

		return Promise.all(promises);
	};

	const { mutate, error, isError, isPending } = useMutation({
		mutationFn: postKYCFileData,
	});

	return {
		mutate,
		error,
		isError,
		isPending,
	};
};
